import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Collapse, IconButton, Box, Typography, Button, Divider } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import Tooltip from '@mui/material/Tooltip';
import DownloadIcon from '@mui/icons-material/Download';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import AddIcon from '@mui/icons-material/Add';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { documentTypeOptions } from '../_Utils/AppDocuCommon';
import { isQuillEmpty } from '../../../utils/quill';
import { Chip } from '@mui/material';

export default function ResultsTable(props) {
  const { results, openRows, onToggleRow, onOpenDownloadDialog, t, searchAi, aiLoading, selectedDocumentForAi, onAiDocQuery, onOpenClassicAiQuestionDialog } = props;

  if (!results || results.length === 0) return null;

  return (
    <TableContainer component={Paper} sx={{ overflowX: 'hidden', width: '100%' }}>
      <Table sx={{ width: '100%', minWidth: 0, maxWidth: '100%', tableLayout: 'auto', borderCollapse: 'collapse', boxSizing: 'border-box', '& td, & th': { borderRight: '1px solid rgba(224,224,224,1)', whiteSpace: 'normal', wordBreak: 'break-word', boxSizing: 'border-box', overflowWrap: 'break-word' }, '& tr > *:last-child': { borderRight: 'none' }, }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold', width: 56, maxWidth: 56, p: 0, textAlign: 'center' }} />
            <TableCell sx={{ fontWeight: 'bold' }}>{t.marca}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>{t.modello}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>{t.codiceMotore}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>{t.headers.cylinders}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>{t.headers.displacement}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>{t.headers.power}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>{t.headers.euro}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>{t.headers.petrolEcu}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {results.map((row, idx) => (
            <React.Fragment key={idx}>
              <TableRow sx={openRows[idx] ? { backgroundColor: '#e3f2fd !important', cursor: 'pointer' } : { cursor: 'pointer' }} onClick={() => onToggleRow(idx)}>
                <TableCell onClick={e => e.stopPropagation()} sx={{ width: 56, maxWidth: 56, p: 0, textAlign: 'center' }}>
                  <IconButton size="small" onClick={() => onToggleRow(idx)}>
                    {openRows[idx] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </IconButton>
                </TableCell>
                <TableCell>{row.machine.brand}</TableCell>
                <TableCell>{row.machine.model}</TableCell>
                <TableCell>{row.machine.engine_code}</TableCell>
                <TableCell align="right">{row.machine.cylinders}</TableCell>
                <TableCell align="right">{row.machine.displacement}</TableCell>
                <TableCell align="right">{row.machine.power}</TableCell>
                <TableCell align="left">{row.machine.euro_code}</TableCell>
                <TableCell>{row.machine.petrol_ecu}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={9} sx={{ p: 0, border: 0 }}>
                  <Collapse in={openRows[idx]} timeout="auto" unmountOnExit>
                    <Box sx={{ p: 2, pb: 2, boxSizing: 'border-box', overflowWrap: 'break-word', minWidth: 0, borderBottom: '1px solid rgba(224,224,224,1)' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, mt: 1 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mr: 2 }}>{t.documents}</Typography>
                        <Box sx={{ flex: 1, borderBottom: '2px solid #e3f2fd' }} />
                      </Box>
                      <ul style={{ paddingLeft: 0, listStyle: 'none' }}>
                        {row.documents && row.documents.length > 0 ? row.documents.map((d) => {
                          const docType = documentTypeOptions.find(opt => opt.name === d.document_type);
                          return (
                            <li key={d.id} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                              <Tooltip title={docType?.label || d.document_type}>
                                <InsertDriveFileIcon fontSize="small" sx={{ color: docType?.color || 'info.main' }} />
                              </Tooltip>
                              <span style={{ fontWeight: 600, cursor: 'pointer', display: 'inline-block', lineHeight: 1.1 }} onClick={() => onOpenDownloadDialog('document', d.id)}>
                                <span style={{ fontWeight: 700, fontSize: 14 }}>{d.name}</span>
                                {d.ecu_type && (<span style={{ display: 'block', fontSize: 12, color: '#888', fontWeight: 500, lineHeight: 1, marginTop: 0 }}>{d.com_brand ? d.com_brand + ' - ' : ''}{d.ecu_type}</span>)}
                              </span>
                              {searchAi && (
                                <Button 
                                  variant="outlined" 
                                  size="small" 
                                  startIcon={<HelpOutlineIcon />} 
                                  onClick={(e) => { e.stopPropagation(); if (props.searchMode === 'ai') { onAiDocQuery(d); } else { onOpenClassicAiQuestionDialog(d); } }} 
                                  disabled={aiLoading && selectedDocumentForAi?.id !== d.id} 
                                  sx={{ ml: 'auto', whiteSpace: 'nowrap' }}>{aiLoading && selectedDocumentForAi?.id === d.id ? '...' : t.aiQueryButton}</Button>)}
                            </li>
                          );
                        }) : <li>{t.nessuno}</li>}
                      </ul>

                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, mt: 3 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mr: 2 }}>{t.packages}</Typography>
                        <Box sx={{ flex: 1, borderBottom: '2px solid #e3f2fd' }} />
                      </Box>
                      <ul style={{ paddingLeft: 0, listStyle: 'none' }}>
                        {row.packages_calibrations && row.packages_calibrations.length > 0 ? row.packages_calibrations.map((pc, i) => (
                          <li key={i}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                              {pc.package && (
                                <>
                                  <Inventory2OutlinedIcon sx={{ color: '#ff9800', fontSize: 18, mr: 0.5 }} titleAccess="Packet" />
                                  <span style={{ fontWeight: 600, cursor: 'pointer', display: 'inline-block', lineHeight: 1.1 }} onClick={() => onOpenDownloadDialog('package', pc.package.id)}>
                                    <span style={{ fontWeight: 700, fontSize: 14 }}>{pc.package.name}</span>
                                    {pc.package.ecu_type && (<span style={{ display: 'block', fontSize: 12, color: '#1976d2', fontWeight: 600, lineHeight: 1, marginTop: 0 }}>{pc.package.ecu_type}</span>)}
                                  </span>
                                </>
                              )}
                              {pc.package && pc.calibration && (<AddIcon sx={{ color: '#888', fontSize: 16, mx: 0.5, verticalAlign: 'middle' }} titleAccess="associato a" />)}
                              {pc.calibration && (
                                <>
                                  <ListAltOutlinedIcon sx={{ color: '#388e3c', fontSize: 18, mr: 0.5 }} titleAccess="Calibration" />
                                  <span style={{ fontWeight: 600, cursor: 'pointer', display: 'inline-block', lineHeight: 1.1 }} onClick={() => onOpenDownloadDialog('calibration', pc.calibration.id)}>
                                    <span style={{ fontWeight: 700, fontSize: 14 }}>{pc.calibration.name}</span>
                                    {pc.calibration.ecu_type && (<span style={{ display: 'block', fontSize: 12, color: '#1976d2', fontWeight: 600, lineHeight: 1, marginTop: 0 }}>{pc.calibration.ecu_type}</span>)}
                                  </span>
                                </>
                              )}
                              {!(pc.package || pc.calibration) && <span>{t.nessuno}</span>}
                            </div>
                          </li>
                        )) : <li>{t.nessuno}</li>}
                      </ul>

                      {!isQuillEmpty(row.machine.user_notes) && (
                        <>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, mt: 1 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mr: 2 }}>{t.userNotes}</Typography>
                            <Box sx={{ flex: 1, borderBottom: '0px solid #e3f2fd' }} />
                          </Box>
                          <div style={{ margin: '12px 0', background: '#fff' }} dangerouslySetInnerHTML={{ __html: row.machine.user_notes }} />
                        </>
                      )}
                    </Box>
                  </Collapse>
                </TableCell>
              </TableRow>
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
